/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { Fragment } from "react";
import { FieldDisplayWrapper } from "cms/fields/layout/field-display-wrapper";
import FeaturedWebpage from "components/featured-webpage";
import { useCurrentDynamicField, useSelectFieldSchema } from "cms/fields/dynamic-field";

const WebpageRefDisplay = () => {
    
    const { field } = useCurrentDynamicField();
    const { name, values } = field || {};
    
    const schema = useSelectFieldSchema(name);
    const { settings: schemaSettings } = schema || {};
    const { options: schemaOptions, } = schemaSettings || {};
    
    // FIXME: need to copy these schema settings options to the saved field options
    // const { type, title } = options || {}

    return (
        <>
            <FieldDisplayWrapper>
                {values &&
                <FeaturedWebpage
                    options={schemaOptions}
                    values={values}
                />
                }
            </FieldDisplayWrapper>
        </>
    );
};
WebpageRefDisplay.displayName = "WebpageRefDisplay";
export { WebpageRefDisplay };
